import React, { memo, Fragment } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import partition from 'lodash/partition';

import SelectedFile from '../entity/SelectedFile';
import ErrorFilesList from './ErrorFilesList';
import FilesToImportList from './FilesToImportList';

const SelectedFilesList = ({
    deleteFile,
    files,
    columnGridCount,
}) => {
    const [filesWithErrors, filesToImport] = partition(files, file => file.hasErrors());

    return (
        <Fragment>
            {filesWithErrors.length > 0 && (
                <ErrorFilesList
                    deleteFile={deleteFile}
                    files={filesWithErrors}
                    columnGridCount={columnGridCount}
                />
            )}

            {filesToImport.length > 0 && (
                <FilesToImportList
                    deleteFile={deleteFile}
                    files={filesToImport}
                    columnGridCount={columnGridCount}
                />
            )}
        </Fragment>
    );
};

SelectedFilesList.propTypes = {
    deleteFile: PropTypes.func.isRequired,
    files: PropTypes.arrayOf(PropTypes.instanceOf(SelectedFile)).isRequired,
    columnGridCount: PropTypes.number.isRequired,
};

export default compose(
    memo,
)(SelectedFilesList);
